<template>
  <div class="container_VideosDatosNovedadForm">
    <PForm
      v-model="validado"
      @accept="action"
      :textAction="$t('action.aceptar')"
      :showCancel="false"
      buttonsAlign="right"
      class="aceptaNovedad_VideosDatosNovedad"
    >
      <div class="text-center" v-if="aceptaNovedad">
        <PFormRadioButton v-model="agregarComentarios" :label="$t('label.agregarComentarios')" />
      </div>

      <br />

      <PRow>
        <PCol md="12" v-if="agregarComentarios || !usuarioXVideo.aceptaNovedad">
          <PFormInputText
            id="input_observaciones"
            v-model="usuarioXVideo.observaciones"
            :label="$t('label.observaciones')"
            type="textarea"
            :rows="5"
            :rules="'required|max:2000'"
          />
        </PCol>
      </PRow>
    </PForm>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VueMethods from "@/vue-methods";
import { IVideo, UsuarioXVideo, Video } from "@/entities";

@Component({ mixins: [VueMethods] })
export class VideosDatosNovedadForm extends Vue {
  @Prop({ required: true }) value!: IVideo;
  @Prop({ required: true }) aceptaNovedad!: boolean;

  valueLocal: IVideo = new Video();
  usuarioXVideo: UsuarioXVideo = new UsuarioXVideo();
  agregarComentarios = false;
  validado = false;

  @Watch("value", { immediate: true, deep: true })
  @Watch("aceptaNovedad", { immediate: true })
  syncData(): void {
    if (!this.value) return;

    this.valueLocal = { ...this.value };
    this.valueLocal.listUsuarios = this.valueLocal.listUsuarios || [];

    const usuario = this.valueLocal.listUsuarios[0] ?? new UsuarioXVideo();

    this.usuarioXVideo = {
      ...usuario,
      fkVideo: this.valueLocal.id,
      aceptaDatos: usuario.aceptaDatos ?? false,
      aceptaNovedad: this.aceptaNovedad ?? usuario.aceptaNovedad ?? false,
      observaciones: usuario.observaciones ?? "",
    };

    if (this.valueLocal.listUsuarios.length === 0) {
      this.valueLocal.listUsuarios.push(this.usuarioXVideo);
    } else {
      this.valueLocal.listUsuarios[0] = this.usuarioXVideo;
    }
  }

  action(): void {
    this.$emit("action", { data: this.valueLocal, action: "confirmObservs" });
    this.agregarComentarios = false;
  }
}
export default VideosDatosNovedadForm;
</script>

<style lang="scss" scoped>
.container_VideosDatosNovedadForm {
  padding: 0 1rem;
}

.aceptaNovedad_VideosDatosNovedad {
  &::v-deep .itemsButtons_PForm {
    margin-right: 0;

    .primary_PButton {
      margin-right: 0;
    }
  }
}
</style>
